<nav [ngClass]="{ hidden: hideNavbar }">
  <mat-toolbar>
    <mat-toolbar-row class="mat-toolbar-row-padding flex flex-start-stretch">
      <div class="navbar-logo hidden sm:flex flex-start-center">
        <img alt="my7N" src="assets/images/logo-my7n.svg" />
      </div>
      <div class="consultant-name sm:hidden">Evaluation of {{ evaluationData?.ConsultantName }}</div>
    </mat-toolbar-row>
  </mat-toolbar>
</nav>
<div class="main-container-wrapper">
  <main id="main-container">
    @if (loading) {
      <div class="view-loader full-screen flex flex-col flex-auto flex-center-center">
        <loader color="primary"></loader>
      </div>
    }
    <div [ngClass]="{ loading: loading }" [@routerOutletVisibility]="loading ? 'hidden' : 'shown'" class="main-view">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>

<div class="chat-bot-container">
  <chat-bot-button [disabled]="false" [message]="chatBotMessage" [title]="evaluationData?.Agent?.Name">
    <avatar
      [avatarUrl]="evaluationData?.Agent?.Avatar"
      [plugEnabled]="false"
      [title]="evaluationData?.Agent?.Name"
    ></avatar>
  </chat-bot-button>
</div>
